
export async function getAppSettings () {
    return (await fetch(process.env.BASE_URL + "appsettings.json").then(resp => {
        return resp.json();
    }))
  }



